export const notFoundObject = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "NOT FOUND",
  headline: "このページは存在しません",
  description:
    "お求めのページは存在しませんでした。入力された URL が正しいか、お確かめください。",
  src: "images/404.svg",
  alt: "not-found",
  topPadding: false,
  largeImage: true,
};
